import React from "react";
import { Spin } from 'antd';

function NotFound(props){
  return (
    <Spin style={{
      width: '100%',
      height: '100%',
      marginTop: 200,
    }}/>
  );
}

export default  React.memo(NotFound);